import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  user: null,
  roles: [],
  role: null, // 'admin' or 'user'
  expiresAt: null,
  isAuthenticated: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      const { token, user, roles, role, expiresAt } = action.payload;
      state.token = token;
      state.user = user;
      state.roles = roles || [];
      state.role = role || null;
      state.expiresAt = expiresAt || null;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.token = null;
      state.user = null;
      state.roles = [];
      state.role = null;
      state.expiresAt = null;
      state.isAuthenticated = false;
    },
    updateUser(state, action) {
      state.user = { ...(state.user || {}), ...(action.payload || {}) };
    },
  },
});

export const { loginSuccess, logout, updateUser } = userSlice.actions;
export default userSlice.reducer;
